import customNav from "./config/nav";
import "./styles/style.scss";
import CustomLogin from "./components/CustomLogin";
global.customNavGlobal = customNav;
global.customRoutes = require("./config/routes");
global.customModules = require("./config/modules");
global.customLogin = CustomLogin
global.customNavElements = false;
require(`@evenlogics/whf-reactadmin`);
